import { gql } from "@apollo/client";

const GET_CONSENTIMIENTO_PACIENTE = gql`
    query consentimientoPaciente($idPaciente: Int!,$idTipoModulo: Int!) {
        consentimientoPaciente(idPaciente: $idPaciente, idTipoModulo: $idTipoModulo) {
            idArchivo
            idPaciente
            idTipoModulo
            idTipoArchivoDocumento
            contentType
            titulo
            archivo
            extension
            fechaAlta
            fechaFirma
        }
    }
`;

export default GET_CONSENTIMIENTO_PACIENTE;

export const adaptConsentimientoPaciente = (consentimientoPaciente) => {
  return {
    idArchivo: consentimientoPaciente?.idArchivo,
    idPaciente: consentimientoPaciente?.idPaciente,
    idTipoModulo: consentimientoPaciente?.idTipoModulo,
    idTipoArchivoDocumento: consentimientoPaciente?.idTipoArchivoDocumento,
    contentType: consentimientoPaciente?.contentType,
    titulo: consentimientoPaciente?.titulo,
    archivo: consentimientoPaciente?.archivo,
    extension: consentimientoPaciente?.extension,
    fechaAlta: consentimientoPaciente?.fechaAlta
  };
};